import { factory, getResponseCamelization } from '@repo-level/core-front';
import { buildCmsUrl, CMSApiBase, getResponseCMS } from './base';

export interface IConfigAPI extends CMSApiBase {
  quest: {
    start: string;
    end: string;
  };
}

export const fetchConfig = factory((r) => () =>
  r<IConfigAPI>(
    'get',
    buildCmsUrl({
      path: 'config',
      additionalParams: { populate: 'deep' },
    }),
    undefined,
    { transformResponse: [getResponseCamelization(), getResponseCMS] }
  )
);
